export default Object.freeze({
    STATUS: {
        ADMITTED: 0,
        DISCHARGED: 1,
        DECEASED: 2,
        TRANSFERRED: 3
    },
    getStatusLabel(status, getLabel) {
        const map = {
            0: getLabel('HOSPITALIZATION_STATUS_ADMITTED'),
            1: getLabel('HOSPITALIZATION_STATUS_DISCHARGED'),
            2: getLabel('HOSPITALIZATION_STATUS_DECEASED'),
            3: getLabel('HOSPITALIZATION_STATUS_TRANSFERRED')
        };
        return map[status] || getLabel('HOSPITALIZATION_STATUS_ADMITTED');
    },
    getStatusList(getLabel) {
        return [
            { value: 0, text: getLabel('HOSPITALIZATION_STATUS_ADMITTED') },
            { value: 1, text: getLabel('HOSPITALIZATION_STATUS_DISCHARGED') },
            { value: 2, text: getLabel('HOSPITALIZATION_STATUS_DECEASED') },
            { value: 3, text: getLabel('HOSPITALIZATION_STATUS_TRANSFERRED') }
        ];
    }
});
